import { render, staticRenderFns } from "./fdInventory24.vue?vue&type=template&id=3987e41e"
import script from "./fdInventory24.vue?vue&type=script&lang=js"
export * from "./fdInventory24.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports